
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
    name: "takeaway",
    data: () => ({
        timeCategories: {
            morgenmad: true,
            frokost: false,
            aftensmad: false
        },
        disableTimeBasedMechanics: true,
        disableCategories: true,
        concept: 'happy-takeaway',
        suppliers: 0,
        loaded: false
    }),
    methods: {
        ...mapMutations('order', ['setLastSeenSubPage', 'setDeliveryMethod']),
        ...mapMutations(['setConcept']),
        ...mapMutations('restaurants', ['setRestaurants']),
        ...mapActions('restaurants', ['getRestaurants']),
        ...mapActions('order', ['changeDeliveryMethod']),
        async checkForSuppliers () {
            // Check if any suppliers in this concept, if not, show "landing page"
            let options = {
                params: {
                    concept: this.concept
                },
            };
            const { data } = await this.$axios.get('/restaurants-count', options);
            this.suppliers = data;
            this.loaded = true;
        }
    },
    async activated() {
        this.setLastSeenSubPage('happy-takeaway');
        this.setConcept('happy-takeaway');
        this.checkForSuppliers();
        //this.setRestaurants([]);
        //this.getRestaurants('happy-takeaway');
    },
    computed: {
        ...mapGetters(['loggedInUser']),
        ...mapGetters('order', ['address', 'isDelivery']),
    },
    mounted () {
        if (!this.isDelivery && !this.address) {
            this.changeDeliveryMethod({ method: 'delivery', onLoad: true });
        } else if (this.address) {
            this.setDeliveryMethod('delivery');
        }
    },
};
